class Page {
  constructor(header, footer, content) {
    this.header = header
    this.footer = footer
    this.content = content ? content : []
  }

  addContent(content) {
    this.content.push(content)
  }

  resetContent() {
    this.content = []
  }
}

export {Page}


// WEBPACK FOOTER //
// ./src/model/Page.js